(function () {
  'use strict';

  angular
    .module('app.service.show-shipment', ['app.global.report']);

})();
